import ColorSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/ColorSetting';
import Padding from 'hb-builder/components/common/SettingsLibrary/CommonSettings/Padding';
import { useBuilderConfigContext } from 'hb-builder/hooks';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';
import { isPaddingTooBig } from 'hb-builder/utils/attributes';

const GlobalSettings = ({
  item,
  onChange,
  permissions: { can: { alertOnCustomPadding } } = {
    can: {},
    flags: {},
  },
}: Omit<ComponentSettingsTab, 'defaultAttributes'>) => {
  const {
    features: { color },
    hivebrite: { networkColors, networkTheming },
  } = useBuilderConfigContext();
  const colorSettingsProps = {
    color,
    networkColors,
    networkTheming,
  };

  const settingProps = { item, onChange };

  return (
    <>
      <ColorSetting
        item={item}
        onChange={onChange}
        settingKey="containerBackgroundColor"
        title={__('Background color')}
        transparent
        {...colorSettingsProps}
      />
      <Padding
        alert={{
          enabled: alertOnCustomPadding,
          fillConditions: (padding) => isPaddingTooBig(padding, 30),
          message: s__(
            'Builder|Please check if this value displays well on mobile',
          ),
        }}
        settingKey="containerPadding"
        title={__('Padding (in pixels)')}
        {...settingProps}
      />
    </>
  );
};

export default GlobalSettings;
